import groupArray from "group-array";
import moment from "moment";

export const pieChartDataWithModal = (data) => {
  const gData = groupArray(data, "name");

  const gData2 = groupArray(data, "name", "parent");

  const result = [];
  for (const key in gData) {
    const element = gData[key];
    const modalCharts = {
      label: key,
      charts: Object.keys(gData2[key]).map((k) => {
        return {
          label: k,
          chartData: gData2[key][k].map((d) => {
            return {
              name: d.mine,
              value: +d?.value,
              siteType: d.siteType,
            };
          }),
          hoSite: gData2[key][k].find((d) => d.siteType === 1) ? true : false,
          count: gData2[key][k].reduce(
            (previous, current) => previous + current.value,
            0
          ),
        };
      }),
    };

    result.push({
      name: key,
      value: element.reduce((previous, current) => previous + current.value, 0),
      modalCharts,
    });
  }

  return result;
};
export const pieChartDataWithModalForTotalVs = (data) => {
  const gData = groupArray(data, "name");

  const gData2 = groupArray(data, "name", "parent");

  const result = [];
  for (const key in gData) {
    const element = gData[key];
    const modalCharts = {
      label: key,
      charts: [
        {
          label: key,
          chartData: Object.keys(gData2[key]).map((d1) => {
            return {
              name: d1,
              value: gData2[key][d1].reduce(
                (previous, current) => previous + current.value,
                0
              ),
              // siteType: d.siteType,
            };
          }),
          // hoSite: Object.keys(gData2[key]).find((d) => gData2[d].siteType === 1) ? true : false,
          // count: Object.keys(gData2[key]).reduce(
          //   (previous, current) => previous + current.value,
          //   0
          // ),
        },
      ],
    };

    result.push({
      name: key,
      value: element.reduce((previous, current) => previous + current.value, 0),
      modalCharts,
    });
  }

  return result;
};

export const stackChartDataFormat = (data) => {
  // console.log(data);
  const gData = groupArray(data, "name");
  const gData1 = groupArray(data, "name1");

  // console.log("chart", chart);
  const holdChartData = [];
  const catergoryData = Object.keys(gData).map((item) => item);
  for (const [key, value] of Object.entries(gData1)) {
    // console.log("sdsfssssssssssssssssss", gData1);
    // console.log(key, value, "asdsdsfdsfsdf");
    const severityWiseIncidentMMData = {
      name: key,
      type: "bar",
      stack: "Ad",
      emphasis: {
        focus: "series",
      },
      data: catergoryData?.map((item) =>
        value.find((d) => (d.name === item ? d.value : 0))
      ),
    };
    holdChartData.push(severityWiseIncidentMMData);
  }
  // console.log("categoryData", catergoryData);
  return { data: holdChartData, categoryData: catergoryData };
};

export const multipleBarChartDataFormat = (data) => {
  // console.log(data);
  const gData = groupArray(data, "name");
  const gData1 = groupArray(data, "name1");

  // console.log("chart", chart);
  const holdChartData = [];
  const catergoryData = Object.keys(gData)?.map((item) => item);
  for (const [key, value] of Object.entries(gData1)) {
    // console.log(key, value, "asdsdsfdsfsdf");
    const severityWiseIncidentMMData = {
      name: key,
      type: "bar",
      // stack: "Ad",
      // emphasis: {
      //   focus: "series",
      // },
      barGap: 0,
      label: {
        normal: {
          show: false,
          position: "insideBottom",
          distance: 5,
          align: "left",
          verticalAlign: "middle",
          rotate: 90,
          formatter: "{c}  {name|{a}}",
          fontSize: 14,
          fontWeight: "bold",
          rich: {
            name: {
              color: "#fff",
            },
          },
        },
      },
      data: catergoryData?.map((item) =>
        value.find((d) => (d.name === item ? d.value : 0))
      ),
    };
    holdChartData.push(severityWiseIncidentMMData);
  }
  return { data: holdChartData, categoryData: catergoryData };
};
export const BasicBarChartWithLabelDataFormat = (data) => {
  // console.log(data);
  const gData = groupArray(data, "name");
  // const gData1 = groupArray(data, "name1");

  // console.log("chart", gData);
  const holdChartData = [];
  const legend = [];
  // const catergoryData = Object.keys(gData).map((item) => item);
  for (const [key, value] of Object.entries(gData)) {
    // console.log(key, value, "asdsdsfdsfsdf");
    legend.push(key);
    const severityWiseIncidentMMData = {
      name: key,
      type: "bar",
      // stack: "Ad",
      // emphasis: {
      //   focus: "series",
      // },
      barGap: "0.5",
      label: {
        normal: {
          show: false,
          position: "insideBottom",
          distance: 5,
          align: "left",
          verticalAlign: "middle",
          rotate: 90,
          formatter: "{c}  {name|{a}}",
          fontSize: 14,
          fontWeight: "bold",
          rich: {
            name: {
              color: "#fff",
            },
          },
        },
      },
      data: [value[0]?.value],
    };
    holdChartData.push(severityWiseIncidentMMData);
  }
  // console.log("legend*/*/8***4*4*74*48498494", holdChartData);
  // return;
  return { data: holdChartData, customToolTip: gData, categoryData: legend };
};
export const BasicBarChartWithLabelMonthDataFormat = (data) => {
  // console.log(data);
  const gData = groupArray(data, "name");
  // const gData1 = groupArray(data, "name1");

  // console.log("chart", gData);
  const holdChartData = [];
  const legend = [];
  // const catergoryData = Object.keys(gData).map((item) => item);
  for (const [key, value] of Object.entries(gData)) {
    // console.log(key, value, "asdsdsfdsfsdf");
    legend.push(key);
    const severityWiseIncidentMMData = {
      name: moment(key, "YYYY-MM").format("MMM YYYY"),
      type: "bar",
      // stack: "Ad",
      // emphasis: {
      //   focus: "series",
      // },
      barGap: "0.5",
      label: {
        normal: {
          show: false,
          position: "insideBottom",
          distance: 5,
          align: "left",
          verticalAlign: "middle",
          rotate: 90,
          formatter: "{c}  {name|{a}}",
          fontSize: 14,
          fontWeight: "bold",
          rich: {
            name: {
              color: "#fff",
            },
          },
        },
      },
      data: [value[0]?.value],
    };
    holdChartData.push(severityWiseIncidentMMData);
  }
  // console.log("legend*/*/8***4*4*74*48498494", holdChartData);
  // return;
  return { data: holdChartData, categoryData: legend };
};
export const BasicBarChartWithLabelDataFormatForCustomToolTip = (data) => {
  // console.log(data);
  const gData = groupArray(data, "name");
  // const gData1 = groupArray(data, "name1");

  // console.log("chart", gData);
  const holdChartData = [];
  const tooltipData = [];
  const legend = [];
  // const catergoryData = Object.keys(gData).map((item) => item);
  for (const [key, value] of Object.entries(gData)) {
    // console.log(key, value, "asdsdsfdsfsdf");
    legend.push(key);
    const severityWiseIncidentMMData = {
      name: key,
      type: "bar",
      // stack: "Ad",
      // emphasis: {
      //   focus: "series",
      // },
      barGap: "0.5",
      label: {
        normal: {
          show: false,
          position: "insideBottom",
          distance: 5,
          align: "left",
          verticalAlign: "middle",
          rotate: 90,
          formatter: "{c}  {name|{a}}",
          fontSize: 14,
          fontWeight: "bold",
          rich: {
            name: {
              color: "#fff",
            },
          },
        },
      },
      data: [value[0]?.value],
    };
    // tooltipData.push(gData[key]);
    holdChartData.push(severityWiseIncidentMMData);
  }

  // console.log("legend*/*/8***4*4*74*48498494", holdChartData);
  // return;
  return { data: holdChartData, custumToolTipData: gData, categoryData: legend };
};
export const basicBarChartWithCustomTooltipDataFormat = (data) => {
  const gData = groupArray(data, "name");
  const outstandingCAPAsRoData = {
    name: Object?.values(gData)
      ?.map((item) =>
        item.map((d) => (d?.parentSiteName != null ? d?.parentSiteName : d?.siteName))
      )
      .filter((d, idx) => idx == 0)
      .join(""),
    type: "bar",
    color: "#5f6bc2",
    emphasis: {
      focus: "series",
    },
    data: Object?.values(gData)?.map((item) => +item.map((d) => d?.value).join()),
  };

  const catergoryData = Object?.values(gData)?.map((item) =>
    item.map((d) => d?.name).join()
  );
  console.log(
    "basicBarChartWithCustomTooltipDataFormat",
    outstandingCAPAsRoData,
    catergoryData,
    gData
  );

  return { data: [outstandingCAPAsRoData], categoryData: catergoryData, dataList: gData };
};
export const barChartDataFormat = (data) => {
  const gData = groupArray(data, "name");
  const outstandingCAPAsRoData = {
    name: Object?.values(gData)
      ?.map((item) =>
        item.map((d) => (d?.parentSiteName != null ? d?.parentSiteName : d?.siteName))
      )
      .filter((d, idx) => idx == 0)
      .join(""),
    type: "bar",
    color: "#5f6bc2",
    emphasis: {
      focus: "series",
    },
    // label: {
    //   normal: {
    //     show: false,
    //     position: "insideBottom",
    //     distance: 5,
    //     align: "left",
    //     verticalAlign: "middle",
    //     rotate: 90,
    //     formatter: "{c}  {name|{a}}",
    //     fontSize: 14,
    //     fontWeight: "bold",
    //     rich: {
    //       name: {
    //         color: "#fff",
    //       },
    //     },
    //   },
    // },
    data: Object?.values(gData)?.map((item) => +item.map((d) => d?.value).join()),
  };

  const catergoryData = Object?.values(gData)?.map((item) =>
    item.map((d) => d?.name).join()
  );
  return { data: [outstandingCAPAsRoData], categoryData: catergoryData };
};

export const multiLineChartDataFormat = (data) => {
  const gData = groupArray(data, "name");
  const gData1 = groupArray(data, "date");
  // console.log("9999999", gData);
  // console.log("gData1", gData1);
  const catergoryData = Object.keys(gData1);

  const multiData = Object.keys(gData).map((d, idx) => {
    const arrayData = gData[d];
    return {
      name: d,
      data: arrayData?.map((r) => r.value),
      type: "line",
      emphasis: {
        focus: "series",
      },
    };
  });
  return { data: multiData, categoryData: catergoryData };
};

export const pyramidIncidentType = {
  fatality: "Fatality",
  seriousBInjury: "Serious Bodily Injury",
  lti: "LTI",
  nearMissMti: "Near Miss + MTI",
  unsafeActUnsafeCondition: "UA + UC",
};

export const pyramidChartDataFormat = (data) => {
  const gData = groupArray(data, "name");
  const catergoryData = Object.keys(gData);

  const pyramidIncidentType = {
    unsafeActUnsafeCondition: "UA + UC",
    nearMissMti: "NM + MTI",
    lti: "LTI",
    seriousBInjury: "Serious Bodily Injury",
    fatality: "Fatality",
  };

  const pyramidKeyOrder = [
    "unsafeActUnsafeCondition",
    "nearMissMti",
    "lti",
    "seriousBInjury",
    "fatality",
  ];

  // console.log("/*/*/////////", catergoryData);

  const result = [];

  for (const key of pyramidKeyOrder) {
    const element = gData[key];
    if (element) {
      result.push({
        name: pyramidIncidentType[key],
        label: {
          show: false,
          position: "inside",
        },
        value: element.reduce((previous, current) => previous + current.value, 0),
      });
    }
  }
  console.log("pyramidChartDataFormat", result);
  return { data: result, categoryData: catergoryData };
};
